import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Grocerystandardorder = () => {
  const [vendorId, setVendorId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [showDetails, setShowDetails] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // ✅ Responsive check
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ✅ Get vendorId from localStorage
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  // ✅ Fetch grocery orders
  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("Missing token");
          alert("Missing token, please log in again.");
          return;
        }

        const response = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // ✅ Normalize response to array
        const data = Array.isArray(response.data) ? response.data : [response.data];

        console.log("📦 Full order data received:", data);

        // ✅ Filter only orders with status "PROCESSING"
        const filteredOrders = data.filter(
          (order) => order.orderStatus === "PROCESSING"
        );

        // ✅ Map and store full order info
        setOrders(
          filteredOrders.map((order) => ({
            orderId: order.orderId,
            userId: order.userId,
            vendorId: order.vendorId,
            location: order.location,
            orderDateTime: order.orderDateTime,
            paymentMethod: order.paymentMethod,
            paymentStatus: order.paymentStatus,
            orderStatus: order.orderStatus,
            sgst: order.sgst,
            cgst: order.cgst,
            subtotal: order.subtotal,
            platformFeeAmount: order.platformFeeAmount,
            total: order.total,
            amountPaid: order.amountPaid,
            amountRemaining: order.amountRemaining,
            cancelReason: order.cancelReason,
            orderItems: order.orderItems || [],
          }))
        );
      } catch (err) {
        console.error("❌ Error fetching orders:", err);
        alert(
          "Failed to fetch orders: " +
          (err.response?.data?.message || err.message)
        );
      }
    };

    fetchOrders();

    // ✅ Auto-refresh every 2 seconds
    const interval = setInterval(fetchOrders, 2000);
    return () => clearInterval(interval);
  }, [vendorId]);

  // ✅ Styles
  const styles = {
    card: {
      border: '1px solid #ccc',
      padding: '16px',
      margin: '16px',
      borderRadius: '10px',
      background: "linear-gradient(to right, #f46b45, #eea849)"
    },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
    pickupBtn: {
      background: '#28a745',
      color: '#fff',
      border: 'none',
      padding: '6px 12px',
      cursor: 'pointer',
      borderRadius: '5px',
      fontWeight: "bold"
    },
    dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' },
    button: (active) => ({
      padding: "8px 16px",
      borderRadius: "8px",
      border: "none",
      color: active ? "white" : "#555",
      backgroundColor: active ? "green" : "#e0e0e0",
      fontWeight: "bold",
      cursor: active ? "default" : "not-allowed",
      boxShadow: active ? "0 4px 10px rgba(0,0,0,0.2)" : "none",
      transition: "0.3s",
    }),
  };

  // ✅ Define the statuses
  const statusSequence = ["PROCESSING", "DELIVERED"];

  return (
    <div>
      <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
        }

        @media screen and (min-width: 768px) {
          .tabs-wrapperyyy {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            margin-left: 0px;
            margin-top: -46px;
          }
        }

        @media screen and (max-width: 768px) {
          .tabs-wrapperyyy {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            margin-left: 0px;
            margin-top: -70px;
          }
          .tab-content {
            width: 100%;
            max-width: 944px;
          }
            .grocery-orders-mobile{
            margin-top:-50px!important;
            }
        }

        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top: 42px;
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: auto;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }
      `}</style>

      <div className="container-fluid">
        <div className="row">

          <div className="col-lg-12 col-md-12 col-sm-12 grocery-orders-mobile" style={{ height: "500px", overflow: "auto", scrollbarWidth: "none" }}>
            {/* ✅ Loop through all orders */}
            {orders.length > 0 ? (
              orders.map((order) => {
                const orderItems = order.orderItems || [];
                const orderId = order.orderId || "N/A";
                const orderType = order.orderType || "Grocery Order";

                return (
                  <div key={orderId} style={styles.card}>
                    <div style={styles.header}>
                      <h3 style={styles.orderId}>Order ID: {orderId}</h3>
                      {/* <button style={styles.pickupBtn}>{orderType}</button> */}
                      <button
                        style={styles.dropdownBtn}
                        onClick={() =>
                          setShowDetails((prev) => ({
                            ...prev,
                            [orderId]: !prev[orderId],
                          }))
                        }
                      >
                        {showDetails[orderId] ? '▲' : '▼'}
                      </button>
                    </div>

                    {showDetails[orderId] && (
                      <>
                        <p style={styles.date}>
                          {order.orderDateTime ? (() => {
                            const dateObj = new Date(order.orderDateTime);
                            const date = dateObj.toLocaleDateString('en-IN', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                            });
                            const time = dateObj.toLocaleTimeString('en-IN', {
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit',
                              hour12: true,
                            });
                            return (
                              <>
                                <span style={{ color: 'black' }}>Date: </span>
                                <span style={{ color: 'white' }}>{date}</span>
                                <br />
                                <span style={{ color: 'black' }}>Time: </span>
                                <span style={{ color: 'white' }}>{time}</span>
                              </>
                            );
                          })() : 'N/A'}
                        </p>

                        {/* ✅ Table with item details */}
                        <table
                          style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginTop: '1rem',
                          }}
                        >
                          <thead>
                            <tr style={{ backgroundColor: '#b15cd6', textAlign: 'center' }}>
                              <th style={{ padding: '8px', border: '1px solid #ddd' }}>S.No</th>
                              <th style={{ padding: '8px', border: '1px solid #ddd' }}>Item Name</th>
                              <th style={{ padding: '8px', border: '1px solid #ddd' }}>Category</th>
                              <th style={{ padding: '8px', border: '1px solid #ddd' }}>Price (₹)</th>
                              <th style={{ padding: '8px', border: '1px solid #ddd' }}>Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {orderItems.length > 0 ? (
                              orderItems.map((item, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    borderBottom: '1px solid #eee',
                                    fontWeight: 'bold',
                                    backgroundColor: '#d4edda',
                                  }}
                                >
                                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{index + 1}</td>
                                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                    {item.groceryItemName || "N/A"}
                                  </td>
                                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                    {item.groceryCategory || "N/A"}
                                  </td>
                                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                    ₹{item.groceryPrice?.toFixed(2) || 0}
                                  </td>
                                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                    {item.quantity ?? 1}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                                  No items found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </>
                    )}

                    {/* ✅ Status Buttons */}
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
                      {statusSequence.map((status) => (
                        <button
                          key={status}
                          style={styles.button(order.orderStatus === status)}
                          disabled
                        >
                          {status}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })
            ) : (
              <p style={{ textAlign: "center", fontWeight: "bold" }}>No orders found</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Grocerystandardorder;
